var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Content',{attrs:{"error":_vm.error,"loading":_vm.loading}},_vm._l((_vm.groupContent),function(groupContent,groupContentIndex){return _c('Card',{key:groupContentIndex},[_c('GroupContent',{attrs:{"group-content":groupContent}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }